<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>属性标签&变量规格式</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleAdd">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="searchTxt"
              placeholder="输入属性标签关键字查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.pic" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      属性标签：<span>{{ item.attrname }}</span>
                    </p>
                    <p>
                      属性标签值：<span>{{ item.attrvalue }}</span>
                    </p>
                    <p>
                      价格变动值：<span>{{ item.num }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      是否重点标签：<span>{{
                        item.isheavy ? "是" : "否"
                      }}</span>
                    </p>
                    <p>
                      属性标签状态：<span>{{
                        item.isuse ? "启用" : "不启用"
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleEdit(item.id)">
                编辑属性标签→
              </div>
            </div>
          </div>
        </template>

        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommondityLabelList } from "../../../api/api";
export default {
  name: "cAttrLabel",
  data() {
    return {
      loading: false,
      searchTxt: "",
      dataList: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let { searchTxt } = this;
      let { id } = this.$route.params;
      this.loading = true;
      let params = {
        cmid: id,
        keyword: searchTxt,
        t: new Date(),
      };
      getCommondityLabelList(params).then((res) => {
        this.dataList = res;
        this.loading = false;
      });
    },
    handleSearch() {
      this.getDetail();
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let cmId = this.$route.params.id;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cAttrLabelSet",
        query: { id, cmId },
      });
    },
    handleAdd() {
      let cmId = this.$route.params.id;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cAttrLabelSet",
        query: { cmId },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
      }
    }
  }
}
</style>